import Image from 'next/image'
import { Link } from '@/navigation'
import { useTranslations } from 'next-intl'

import type { FC } from 'react'
import type { IProjectsData } from '@/types'

const ProjectsCard: FC<IProjectsData> = (data) => {
  const t = useTranslations('Buttons')

  return (
    <div className="flex h-full flex-col rounded-xl border border-secondary-light bg-white p-5 md:p-10">
      <h5 className="mb-2">{data.name}</h5>

      <p className="mb-6 flex-1 text-secondary-dark">
        {data?.short_desc}
      </p>

      <div className="mb-6 aspect-video w-full overflow-hidden rounded-xl">
        <Image
          src={data.image}
          alt={data.name}
          width={1600}
          height={900}
          className="h-full w-full object-contain"
        />
      </div>

      <Link
        href={'/projects/' + data.slug}
        className="btn-primary-outlined"
        aria-label={t('More')}
      >
        {t('More')}
      </Link>
    </div>
  )
}

export default ProjectsCard